import { Stack, Typography } from '@mui/material'
import { useTimeWindowLabels } from '../hooks/useTimeWindowLabels'
import { DrivingTime } from './DrivingTime'

interface Props {
  hidden: boolean
}

export function FirstTimeWindow(props: Props) {
  const label = useTimeWindowLabels()

  if (props.hidden) {
    return null
  }

  return (
    <Stack gap={1}>
      <Typography variant="body2" color="text.secondary">
        {label[0]}
      </Typography>
      <DrivingTime fieldName="firstTimeWindowValue" />
    </Stack>
  )
}
